export const formatAvaName = (avaName: string) => {
  if (!avaName) return '';

  const validAvaName = avaName.replace(/[^A-Z0-9]/gi, '');
  return validAvaName.toLocaleLowerCase();
};

export const isAvaRoomValid = (room: string) => typeof room === 'string' && room && room.length >= 3;
